module.exports = __webpack_public_path__ + "static/img/011.9d1a3af6.jpg";